// eslint-disable-next-line import/prefer-default-export
export const TYPES = {
	CHARGE: 'charge',
	PAYMENT: 'payment',
	OVERVIEW: 'overview',
};
